import {odxIconSets} from "../constants";
import React from "react";
import '@odx/icons';
import '@odx/icons/core';

type OdxIconSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface OdxIconProps {
    name: string;
    size?: OdxIconSize;
    iconSet: odxIconSets;
    children?: React.ReactNode;
    className?: string;
}

const OdxIcon: React.FC<OdxIconProps> = ({name, size = "md", children, className, iconSet}) => {
    const isCoreSet = iconSet === odxIconSets.core;
    const resolvedName = isCoreSet ? name : `${iconSet}::${name}`;

    return (
        <odx-icon
            className={className}
            name={resolvedName}
            set={isCoreSet ? undefined : iconSet}
            size={size}
        >
            {children}
        </odx-icon>
    );
};

export default OdxIcon;
